import _ from 'underscore';
import { useState, useMemo, useContext, useEffect, useCallback } from 'react';
import { PreferenceContext } from '@bingads-webui-react/preference-context';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { getGeneralInsightsPreferences, saveGeneralInsightsPreferences } from '@bingads-webui-campaign-react/competition-core';
import { CAMPAIGN_TYPES, METRIC_PREFERENCE_KEY_NAME } from '@bingads-webui-campaign/competition-auction-insight-preferences';
import {
  METRICS,
  getLocalizedMetrics
} from '@bingads-webui-campaign-react/advisor-chart';
import config from '@bingads-webui-component-legacy/config/index';

import { getCampaignType } from '../utils/get-campaign-type';
import { Metric } from '../utils/types';

export const usePreferenceMetrics = ({ onMetricSet }: { onMetricSet: Function; }): {
  metrics: Metric[];
  selectedMetric: Metric;
  setMetric: Function;
} => {
  const serverContext = useContext(ServerContext) as any;
  const preferenceService = useContext(PreferenceContext) as any;
  const preferences = getGeneralInsightsPreferences(preferenceService);
  // @ts-ignore
  const legacyI18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/dashboard-cards');

  const campaignType = getCampaignType(serverContext, config.get('CurrentCampaign'));

  const metrics = useMemo(() => getLocalizedMetrics(
    legacyI18n,
    campaignType === CAMPAIGN_TYPES.Shopping,
    serverContext?.Permissions?.IsAvgPositionDeprecationPhase1Enabled,
    serverContext?.Permissions?.IsAvgPositionDeprecationPhase2Enabled
  ), [campaignType, legacyI18n, serverContext]);

  const metricPreferenceKeyName = METRIC_PREFERENCE_KEY_NAME[campaignType];
  const [selectedMetric, setMetricValue] = useState<Metric>(_.find(metrics, (m: Metric) => m.metric === preferences[metricPreferenceKeyName])
    || _.find(metrics, (m: Metric) => m.metric === METRICS.ImpressionShare));

  const setMetric = useCallback((metricObj) => {
    setMetricValue(metricObj);
    onMetricSet(metricObj.metric);
    saveGeneralInsightsPreferences({
      [metricPreferenceKeyName]: metricObj.metric,
    }, preferenceService);
  }, [metricPreferenceKeyName, onMetricSet, preferenceService]);

  return {
    metrics,
    selectedMetric,
    setMetric,
  };
};
